import React from 'react';
import { styled } from 'linaria/react';
import { RowProducts } from '../../ui/ProductRow/RowProducts';
import { theme } from '../../Theming/Theming';

const RelatedWrapper = styled('div')`
  margin: 1rem 0 3rem 0;
  width: 100%;
  background: #f5f5f5;
  padding: 2rem 0;
  > header {
    margin-bottom: 1rem;
    text-align: center;
  }
  ${theme.above.lg} {
    display: flex;
    > header {
      width: 19%;
      display: flex;
      margin-right: 1%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 5px;
      position: relative;
    }
    > div {
      width: 80%;
    }
  }
  .product-card {
    .product-card-inner {
      header h4 {
        padding-right: 0;
      }
      [data-flight-price] {
        justify-content: center;
      }
      text-align: center;
      .buttons {
        background: #f5f5f5;
        > button {
          width: 100%;
          border-radius: 30px;
          margin-top: 1rem;
        }
      }
    }
    .product-card-detail {
      margin: 0;
      padding: 1rem 0 0.5rem;
      background: #f5f5f5;
    }
    .image-wrapper {
    }
  }
`;

const RelatedProducts = ({ products, title, subTitle }) => {
  const category = {
    name: 'Related products',
    products: {
      result: products,
    },
  };

  return (
    <RelatedWrapper id="related-products">
      <header>
        <h3 className="secondary-font">{title}</h3>
        <h3>{subTitle}</h3>
      </header>
      <RowProducts
        category={category}
        slider={true}
        quickBuy={true}
        showFavorite={false}
      />
    </RelatedWrapper>
  );
};

export default RelatedProducts;
